export default "__VITE_ASSET__DJDbTpgb__"